var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "previous__item" },
    [
      _c("h2", { staticClass: "previous__caption" }, [
        _vm._v(_vm._s(_vm.category.categoryDescription))
      ]),
      _c("AppSlider", {
        attrs: {
          items: _vm.category.items,
          extension: "jpg",
          sliderType: "oneSlideInRow"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5498c3c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5498c3c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PreviousContestItem.vue
// module id = a7pY
// module chunks = 1